// @flow

import { airflowActions } from './airflowActionCreator';

const initialState = {
  isLoading: false,
  isSubmitInProgress: false,
  clientsData: []
};

const airFlowReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case airflowActions.SET_SUBMIT_LOADER: {
      return Object.assign({}, state, {
        isSubmitInProgress: action.payload.isSubmitInProgress
      });
    }
    default: {
      return state;
    }
  }
};

export default airFlowReducer;
